import {
    createEntityAdapter,
    EntityAdapter,
    EntityState,
    Update,
} from '@ngrx/entity';
import { createReducer, on, StoreModule } from '@ngrx/store';
import { CommunityItemSearchFilterDto } from '../models/community-item-search-filter.dto';
import * as CommunityFilterActions from './community-filter.actions';

export const communityFilterFeatureKey = 'communityFilters';
export type CommunityFilterState = EntityState<CommunityItemSearchFilterDto>;

export const adapter: EntityAdapter<CommunityItemSearchFilterDto> =
    createEntityAdapter<CommunityItemSearchFilterDto>({
        selectId: (filter: CommunityItemSearchFilterDto) => filter.id,
    });

export const initialState: CommunityFilterState = adapter.getInitialState();

export const communityFilterReducer = createReducer(
    initialState,
    on(CommunityFilterActions.SetCommunityFilter, (state, props) => {
        return adapter.upsertOne(props.item.toDto(), state);
    }),
    on(CommunityFilterActions.ClearCacheCommunityFilter, (state) => {
        const updates: Update<CommunityItemSearchFilterDto>[] = [];
        for (const [, filter] of Object.entries(state.entities)) {
            if (filter) {
                updates.push({
                    changes: {
                        ...filter,
                        cacheDate: undefined,
                    },
                    id: filter.id,
                });
            }
        }
        return adapter.updateMany(updates, state);
    })
);

export const communityFilterStoreModule = StoreModule.forFeature(
    communityFilterFeatureKey,
    communityFilterReducer
);
